import { SET_SELECTED_LEVEL, SET_SELECTED_GAME } from "../actions/action_types";

const initialState = {
    selectedGame: 0,
    selectedlLevel: 0,
};

const gameplayReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SELECTED_LEVEL:
            return { ...state, selectedLevel: action.selectedLevel };
        case SET_SELECTED_GAME:
            return { ...state, selectedGame: action.selectedGame };
        default:
            return state;
    }
};
export default gameplayReducer;
